// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"a553044b","660":"8ad2f567","5604":"87435df4","7201":"44d7851f","7649":"b3b0da1b"}[chunkId] + ".chunk.css";
};